import React from 'react';
import { FormattedMessage } from 'react-intl';
import { v1 as uuid } from 'uuid';
import BaseModal from '../../../_shared/components/BaseModal';
import {
  StyledSendToClosingContainer,
  StyledSendToClosingFooter,
  StyledSendToClosingHeader,
  StyledSendToClosingListItem
} from './Styles';
import {
  CancelButton,
  StartNegotiationButton
} from '../TutorialNegotiationModal/Styles';
import ROUTES from '../../Routes/constants';

const SendToClosingModal = ({
  modalIsOpen,
  onSendToClosing,
  onClose,
  topBid,
  associatedTrade,
  associatedTradeId,
  isInternalTrade,
  isLoading
}) => {
  const getMessageKey = () => {
    const isVdp = window.location.pathname.startsWith(ROUTES.TRADE_URI);
    const isDuplicateDgnTrade =
      (isVdp && associatedTrade?.network?.isDealerGroupNetwork === false) ||
      (!isVdp && isInternalTrade);
    const isOpenAssociatedTrade =
      (isVdp && associatedTrade?.network?.isDealerGroupNetwork) ||
      (!isVdp && isInternalTrade === false && associatedTradeId);

    if (isDuplicateDgnTrade)
      return 'modal.decision.sendToClosing.message.dgnTrade';

    if (isOpenAssociatedTrade)
      return 'modal.decision.sendToClosing.message.openTrade';

    return 'modal.decision.sendToClosing.message0';
  };
  const messages = [<FormattedMessage id={getMessageKey()} />];

  const handleClickOnClosing = async () => {
    onSendToClosing(topBid);
  };

  return (
    <BaseModal
      isOpen={modalIsOpen}
      onRequestClose={onClose}
      isClickEscClose
      isClickOverlayClose
      padding="0px"
      width={490}
    >
      <StyledSendToClosingContainer>
        <StyledSendToClosingHeader data-testid="send-to-closing-modal-title">
          <FormattedMessage id="modal.decision.sendToClosing.title" />
        </StyledSendToClosingHeader>
        {messages.map(message => {
          return (
            <StyledSendToClosingListItem
              key={uuid()}
              data-testid="send-to-closing-modal-title-msg"
            >
              {message}
            </StyledSendToClosingListItem>
          );
        })}
        <StyledSendToClosingFooter>
          <CancelButton
            data-testid="send-to-closing-modal-cancel"
            onClick={onClose}
          >
            <FormattedMessage id="modal.cancel" />
          </CancelButton>
          <StartNegotiationButton
            data-testid="send-to-closing-modal-submit"
            onClick={handleClickOnClosing}
          >
            {isLoading ? (
              <FormattedMessage id="modal.confirmation.loading" />
            ) : (
              <FormattedMessage id="modal.decision.sendToClosing.button.sendToClosing" />
            )}
          </StartNegotiationButton>
        </StyledSendToClosingFooter>
      </StyledSendToClosingContainer>
    </BaseModal>
  );
};

export default SendToClosingModal;
